module.exports = "/_next/static/images/NoTransaction-c18f77761a4079dc79fd33b29c485c65.png";